import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {ContactContainerModel} from '../../../../../../models/aggregates/erp/contact';
import { ApiVisa } from '../../shared';

@Injectable({providedIn: 'root'})
export class ContactService extends BaseApiTemplateService<ContactContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'contacts';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'contacts';
    this.httpClient = http;
  }

  exportContactCsvAsBlob(authorization: string, apiVisa: ApiVisa){
    const CSV_URL = this.apiUrl + '/export/csv';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode" : apiVisa.tenantCode });
    return this.httpClient
      .get(CSV_URL, { headers, responseType: 'blob', reportProgress: true, observe: "events"});
  }
}
